import { StandupTable } from './table-helper'
import { useAxiosWithHeader } from '../../utils'
import messageInteraction from '../Analytics/utils/messageInteraction'
import { useEffect, useState } from 'react'
import { URLBACK } from '../../assets/urls'
import { useDispatch, useSelector } from 'react-redux'
import { Organization } from '../../reducers/organizationReducer'
import { Standups } from '../../reducers/standupReducer'
import { fetchSlackChannelsAndUpdateReducer } from '../Settings/utils'

export default function StandupSetting({ engineer, globalLoader, isAdmin }) {
  const organization = useSelector(Organization.selectors.getOrganization)
  const axios = useAxiosWithHeader()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const myStandups = useSelector(Standups.selectors.getMyStandups)
  const otherStandups = useSelector(Standups.selectors.getOtherStandups)

  async function fetchOrganizationStandups() {
    if (!(myStandups?.length > 0) && !(otherStandups?.length > 0)) {
      try {
        const res = await axios.get(
          `${URLBACK}settings/fetchOrganizationStandups?engId=${engineer.id}&orgId=${organization.id}`,
        )
        if (res.data.length > 0) {
          const myStandups = res.data.filter(
            (standup) => !standup.creator?.id || standup.creator?.id === engineer.id,
          )
          const otherStandups = res.data.filter(
            (standup) => standup.creator?.id && standup.creator?.id !== engineer.id,
          )
          dispatch(Standups.actions.setData({ myStandups, otherStandups }))
        }
      } catch (e) {
        messageInteraction({
          content: 'Error fetching your standups.',
          type: 'error',
        })
        console.log('error in fetchOrganizationStandups:', e)
      }
    }
  }
  async function fetchTeams() {
    try {
      // should only be working for the engineer login, not admin login
      if (!(organization.teams?.length > 0)) {
        const res = await axios.get(
          `${URLBACK}teams/fetchOrganizationTeams/${organization.id}`,
        )
        dispatch(Organization.actions.setData({ teams: res.data }))
      }
    } catch (e) {
      messageInteraction({
        content: 'Error fetching your GitHub teams.',
        type: 'error',
      })
      console.log('error in fetchTeams:', e)
    }
  }

  useEffect(() => {
    if (!engineer?.id || !organization?.id) return

    async function handleFetchData() {
      try {
        await Promise.allSettled([
          fetchOrganizationStandups(),
          fetchTeams(),
          fetchSlackChannelsAndUpdateReducer({
            organization,
            user: engineer,
            axios,
            dispatch,
            setLoading,
          }),
        ])
      } catch (error) {
        console.log('Error in handleFetchData:', error)
        setLoading(false)
      }
    }

    handleFetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engineer?.id, organization?.id])

  // if (globalLoader) return 'bloop'
  return (
    <div className="">
      {/* personal standups */}
      <StandupTable
        personalStandup={true}
        engineer={engineer}
        axios={axios}
        loading={loading}
        standups={myStandups}
        isAdmin={isAdmin}
      />

      {/* other's standups */}
      <StandupTable personalStandup={false} standups={otherStandups} loading={loading} />
    </div>
  )
}
